import { useEffect, useState } from 'react'
import { Image, StyleSheet, View, ViewProps, useWindowDimensions } from 'react-native'
import { Photo } from 'zens-store'

import Placeholder from '@dms/../assets/images/placeholder.png'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  photo: {
    width: '100%',
    height: '100%',
  },
})

interface Props extends ViewProps {
  photo: Photo
}

const MAX_WIDTH = 800

const FeedbackPhoto = (props: Props) => {
  const { photo, style, ...otherProps } = props
  const screenDimensions = useWindowDimensions()

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    Image.getSize(`${photo?.url}`, (width, height) => {
      const newWidth = (width * Math.min(height, screenDimensions.height * 0.8)) / height
      const newHeight = (height * Math.min(MAX_WIDTH, width, screenDimensions.width * 0.8)) / width
      if (newWidth < Math.min(MAX_WIDTH, width, screenDimensions.width * 0.8)) {
        setDimensions({ width: newWidth, height: Math.min(height, screenDimensions.height * 0.8) })
      } else {
        setDimensions({ width: Math.min(MAX_WIDTH, width, screenDimensions.width * 0.8), height: newHeight })
      }
    })
  }, [photo.url])

  const containerStyle = dimensions

  return (
    <View style={[styles.container, containerStyle, style]} {...otherProps}>
      <Image source={{ uri: photo.url }} style={styles.photo} defaultSource={Placeholder} />
    </View>
  )
}

export default FeedbackPhoto
